export default __webpack_public_path__ + "static/media/albertainnovates-logo.091faf70.png";